import { DocumentIcon } from '../../../icons';
import { Chip } from '../../atoms/Chip';
import { Stack } from '../../atoms/Stack';
import { Tag } from '../../atoms/Tag';
import { Typography } from '../../atoms/Typography';
import type { CommunicationDocument } from './useCommunicationCard';

type PeopleProps = {
  providerName: string | null;
  contactName: string | null;
  // An exchange reads sender then recipient; an "Autre" action keeps contact / provider.
  isExchange: boolean;
};

type DocumentsProps = {
  documents: CommunicationDocument[];
};

/** Sender and recipient line shared by the card and its full-view dialog. */
export function CommunicationPeople(props: PeopleProps) {
  if (!props.providerName && !props.contactName) {
    return null;
  }

  const contactLabel = props.isExchange ? 'De' : 'Contact';
  const providerLabel = props.isExchange ? 'À' : 'Prestataire';

  return (
    <Stack direction="row" spacing={1} alignItems="center" wrap="wrap">
      {props.contactName ? (
        <Typography variant="caption">
          {contactLabel} : <strong>{props.contactName}</strong>
        </Typography>
      ) : null}
      {props.providerName ? (
        <Typography variant="caption">
          {providerLabel} : <strong>{props.providerName}</strong>
        </Typography>
      ) : null}
    </Stack>
  );
}

/** Attached documents: a link chip when the file has a URL, a passive tag otherwise. */
export function CommunicationDocuments(props: DocumentsProps) {
  if (props.documents.length === 0) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center" wrap="wrap">
      {props.documents.map((doc, index) => {
        const docUrl = doc.url || doc.file_url;
        if (docUrl) {
          return (
            <Chip
              key={doc.id ?? index}
              icon={<DocumentIcon fontSize="small" />}
              label={doc.name}
              href={docUrl}
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              variant="outlined"
            />
          );
        }

        return (
          <Tag
            key={doc.id ?? index}
            color="default"
            label={doc.name}
            icon={<DocumentIcon fontSize="small" />}
          />
        );
      })}
    </Stack>
  );
}
